import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Los-Angeles.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol for Mobile App Development in Los Angeles
            </h2>
            <p>
              When considering mobile app development in Los Angeles, TekRevol
              emerges as the preferred choice. Our dedication to excellence and
              a track record of success make us the ideal partner for
              transforming your digital aspirations into reality. At TekRevol,
              our team of app developers in los angeles, designers, and
              strategists boasts extensive knowledge of the mobile app
              landscape.
            </p>
            <p>
              We remain at the forefront of the industry, continuously embracing
              the latest technologies and trends. This ensures that the mobile
              apps we create for your business are cutting-edge and aligned with
              the latest industry standards. One of the key aspects that sets us
              apart is our commitment to providing custom solutions. We
              understand that one-size-fits-all approaches rarely yield the best
              results. That's why we tailor each mobile app to meet your
              specific business needs.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
